import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import api from '../services/api';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,

      login: async (phone, password) => {
        set({ isLoading: true, error: null });

        try {
          console.log('Attempting login with:', { phone });

          const response = await api.post('/accounts/token/', {
            phone: phone,
            password: password,
          });

          console.log('Login response:', response.data);

          const { access, refresh } = response.data;

          // ذخیره توکن‌ها
          localStorage.setItem('access_token', access);
          localStorage.setItem('refresh_token', refresh);

          // تنظیم وضعیت اولیه
          set({
            accessToken: access,
            refreshToken: refresh,
            isAuthenticated: true,
            error: null,
          });

          // دریافت اطلاعات کاربر
          try {
            const userResponse = await api.get('/accounts/profile/', {
              headers: {
                Authorization: `Bearer ${access}`
              }
            });
            console.log('User profile loaded:', userResponse.data);
            set({ 
              user: userResponse.data,
              isLoading: false 
            });
          } catch (userError) {
            console.error('Error fetching user profile:', userError);
            set({ isLoading: false });
          }

          return { success: true };
        } catch (error) {
          console.error('Login error:', error);
          let errorMessage = 'خطا در ورود به حساب کاربری';

          if (error.response?.data?.detail) {
            errorMessage = error.response.data.detail;
          } else if (error.response?.data?.non_field_errors) {
            errorMessage = error.response.data.non_field_errors[0];
          } else if (error.response?.status === 401) {
            errorMessage = 'شماره تلفن یا رمز عبور اشتباه است';
          }

          set({
            error: errorMessage,
            isLoading: false,
            isAuthenticated: false,
          });

          return { success: false, error: errorMessage };
        }
      },

      logout: () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          isAuthenticated: false,
          isLoading: false,
          error: null,
        });
      },

      loadUser: async () => {
        const token = localStorage.getItem('access_token');
        console.log('loadUser called - token:', token ? 'exists' : 'not found');

        if (!token) {
          set({ isLoading: false, isAuthenticated: false });
          return;
        }

        set({ isLoading: true });

        try {
          const response = await api.get('/accounts/profile/', {
            headers: { Authorization: `Bearer ${token}` }
          });
          console.log('User loaded successfully:', response.data);
          set({
            user: response.data,
            isAuthenticated: true,
            isLoading: false
          });
        } catch (error) {
          console.error('Load user error:', error);
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          set({
            user: null,
            isAuthenticated: false,
            isLoading: false
          });
        }
      },

      updateUser: async (data) => {
        const token = localStorage.getItem('access_token');

        if (!token) {
          throw new Error('No token found');
        }

        try {
          const response = await api.patch('/accounts/profile/', data, {
            headers: { Authorization: `Bearer ${token}` }
          });
          set({ user: response.data });
          return response.data;
        } catch (error) {
          console.error('Update user error:', error);
          throw error;
        }
      },

      clearError: () => set({ error: null }),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);